import moment from 'moment';

import * as actionTypes from 'actions/orderSwitchManagementActions';

const initFilter = {
  startDate: moment()
    .subtract(30, 'days')
    .toDate(),
  endDate: moment().add(30, 'days').toDate(),
  status: 'toan_bo'
};
const initialState = {
  listOrder: [],
  filter: initFilter,
  loading: false,
  selectedOrder: []
};

const orderManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_FILTER_DATA: {
      return {
        ...state,
        filter: {
          ...state.filter,
          ...action.data
        }
      };
    }

    case actionTypes.SET_ORDERS: {
      return {
        ...state,
        listOrder: action.listOrder,
        loading: false,
        selectedOrder: []
      };
    }

    case actionTypes.SET_LOADING: {
      return {
        ...state,
        loading: action.loading
      };
    }

    case actionTypes.SET_SELECTED_ORDER: {
      return {
        ...state,
        selectedOrder: action.selected
      };
    }

    default: {
      return state;
    }
  }
};

export default orderManagementReducer;
